export const STARTPAGE = "startpage";
export const STANDARDPAGE = "standardpage";
export const ARTICLEPAGE = "articlepage";
export const EVENTPAGE = "eventpage";
export const JOBADPAGE = "jobAdpage";
export const NEWSPAGE = "newsItempage";
export const EMPLOYEEPAGE = "employeepage";
export const SEARCHPAGE = "listpage";
export const ERRORPAGE = "errorpage";
export const MAPPAGE = "mappage";
export const COOKIELISTPAGE = "cookieListPage";
export const FORMPAGE = "formPage";
export const PASSAGEPAGE = "passagepage";
export const VIDEOPAGE = "videopage";
export const LOGINPAGE = "loginPage";
export const PROFILEPAGE = "profilePage";
export const LISTPAGEWITHCATEGORIES = "listPageWithCategories";
